// PNG Badge Images - Organized by category/template
// Import PNG badges as image URLs

// ===== CATEGORY BADGES =====
import audioSpeechProcessingBadge from "./audio-speech-processing.png";
import chatBadge from "./chat.png";
import computerVisionBadge from "./computer-vision.png";
import conversationalAiBadge from "./conversational-ai.png";
import generativeAiBadge from "./generative-ai.png";
import medicalImagingBadge from "./medical-imaging.png";
import naturalLanguageProcessingBadge from "./natural-language-processing.png";
import rankingAndScoringBadge from "./ranking-and-scoring.png";
import structuredDataParsingBadge from "./structured-data-parsing.png";
import timeSeriesAnalysisBadge from "./time-series-analysis.png";
import videosBadge from "./videos.png";

// ===== AUDIO SPECIALIZATIONS =====
import asrBadge from "./audio/asr.png";
import asrUsingSegmentsBadge from "./audio/asr-using-segments.png";
import conversationalAnalysisBadge from "./audio/conversational-analysis.png";
import intentClassificationBadge from "./audio/intent-classification.png";
import signalQualityDetectionBadge from "./audio/signal-quality-detection.png";
import soundEventDetectionBadge from "./audio/sound-event-detection.png";
import speakerSegmentationBadge from "./audio/speaker-segmentation.png";
import speechTranscriptionBadge from "./audio/speech-transcription.png";

// ===== CHAT SPECIALIZATIONS =====
import chatbotBadge from "./chat/chatbot.png";
import chatEvalBadge from "./chat/chat-eval.png";
import chatLlmEvalBadge from "./chat/chat-llm-eval.png";
import chatRedTeamBadge from "./chat/chat-red-team.png";
import chatRlhfBadge from "./chat/chat-rlhf.png";

// ===== COMPUTER VISION SPECIALIZATIONS =====
import imageClassificationBadge from "./computer-vision/image-classification.png";
import objectDetectionBboxesBadge from "./computer-vision/object-detection-bboxes.png";
import objectDetectionEllipsesBadge from "./computer-vision/object-detection-ellipses.png";
import semanticSegmentationMasksBadge from "./computer-vision/semantic-segmentation-masks.png";
import semanticSegmentationPolygonsBadge from "./computer-vision/semantic-segmentation-polygons.png";
import keypointsBadge from "./computer-vision/keypoints.png";
import visualQuestionAnsweringBadge from "./computer-vision/visual-question-answering.png";
import imageCaptioningBadge from "./computer-vision/image-captioning.png";
import ocrBadge from "./computer-vision/ocr.png";
import textToImageGenerationBadge from "./computer-vision/text-to-image-generation.png";

// ===== NLP SPECIALIZATIONS =====
import textClassificationBadge from "./nlp/text-classification.png";
import namedEntityRecognitionBadge from "./nlp/named-entity-recognition.png";
import contentModerationBadge from "./nlp/content-moderation.png";
import textSummarizationBadge from "./nlp/text-summarization.png";
import machineTranslationBadge from "./nlp/machine-translation.png";
import questionAnsweringBadge from "./nlp/question-answering.png";
import relationExtractionBadge from "./nlp/relation-extraction.png";
import taxonomyBadge from "./nlp/taxonomy.png";

// ===== MEDICAL SPECIALIZATIONS =====
import dicom3dBadge from "./medical/dicom-3d.png";
import dicomBboxBadge from "./medical/dicom-bbox.png";
import dicomClassificationBadge from "./medical/dicom-classification.png";
import dicomKeypointBadge from "./medical/dicom-keypoint.png";
import dicomSegmentationBadge from "./medical/dicom-segmentation.png";

// ===== VIDEOS SPECIALIZATIONS =====
import videoClassificationBadge from "./videos/video-classification.png";
import videoFrameClassificationBadge from "./videos/video-frame-classification.png";
import videoObjectTrackingBadge from "./videos/video-object-tracking.png";
import videoTimelineSegmentationBadge from "./videos/video-timeline-segmentation.png";

// ===== GENERATIVE AI SPECIALIZATIONS =====
import chatbotAssessmentBadge from "./generative-ai/chatbot-assessment.png";
import humanFeedbackCollectionBadge from "./generative-ai/human-feedback-collection.png";
import llmRankerBadge from "./generative-ai/llm-ranker.png";
import responseGradingBadge from "./generative-ai/response-grading.png";
import supervisedLlmBadge from "./generative-ai/supervised-llm.png";
import visualRankerBadge from "./generative-ai/visual-ranker.png";

// ===== CONVERSATIONAL AI SPECIALIZATIONS =====
import intentSlotFillingBadge from "./conversational-ai/intent-slot-filling.png";
import responseGenerationBadge from "./conversational-ai/response-generation.png";
import responseSelectionBadge from "./conversational-ai/response-selection.png";
import coreferenceResolutionBadge from "./conversational-ai/coreference-resolution.png";

// ===== RANKING AND SCORING SPECIALIZATIONS =====
import searchEngineBadge from "./ranking-and-scoring/search-engine.png";
import serpRankingBadge from "./ranking-and-scoring/serp-ranking.png";
import documentRetrievalBadge from "./ranking-and-scoring/document-retrieval.png";
import textToImageBadge from "./ranking-and-scoring/text-to-image.png";
import contentBasedImageSearchBadge from "./ranking-and-scoring/content-based-image-search.png";
import asrHypothesesBadge from "./ranking-and-scoring/asr-hypotheses.png";
import pairwiseClassificationBadge from "./ranking-and-scoring/pairwise-classification.png";
import pairwiseRegressionBadge from "./ranking-and-scoring/pairwise-regression.png";

// ===== STRUCTURED DATA PARSING SPECIALIZATIONS =====
import tabularDataBadge from "./structured-data-parsing/tabular-data.png";
import pdfClassificationBadge from "./structured-data-parsing/pdf-classification.png";
import htmlEntityRecognitionBadge from "./structured-data-parsing/html-entity-recognition.png";
import freeformMetadataBadge from "./structured-data-parsing/freeform-metadata.png";

// ===== TIME SERIES ANALYSIS SPECIALIZATIONS =====
import timeSeriesForecastingBadge from "./time-series-analysis/time-series-forecasting.png";
import anomalyDetectionBadge from "./time-series-analysis/anomaly-detection.png";
import changePointDetectionBadge from "./time-series-analysis/change-point-detection.png";
import activityRecognitionBadge from "./time-series-analysis/activity-recognition.png";
import signalQualityBadge from "./time-series-analysis/signal-quality.png";

// ===== EXPORTS =====
export {
  // Categories
  audioSpeechProcessingBadge,
  chatBadge,
  computerVisionBadge,
  conversationalAiBadge,
  generativeAiBadge,
  medicalImagingBadge,
  naturalLanguageProcessingBadge,
  rankingAndScoringBadge,
  structuredDataParsingBadge,
  timeSeriesAnalysisBadge,
  videosBadge,
  // Audio
  asrBadge,
  asrUsingSegmentsBadge,
  conversationalAnalysisBadge,
  intentClassificationBadge,
  signalQualityDetectionBadge,
  soundEventDetectionBadge,
  speakerSegmentationBadge,
  speechTranscriptionBadge,
  // Chat
  chatbotBadge,
  chatEvalBadge,
  chatLlmEvalBadge,
  chatRedTeamBadge,
  chatRlhfBadge,
  // Computer Vision
  imageClassificationBadge,
  objectDetectionBboxesBadge,
  objectDetectionEllipsesBadge,
  semanticSegmentationMasksBadge,
  semanticSegmentationPolygonsBadge,
  keypointsBadge,
  visualQuestionAnsweringBadge,
  imageCaptioningBadge,
  ocrBadge,
  textToImageGenerationBadge,
  // NLP
  textClassificationBadge,
  namedEntityRecognitionBadge,
  contentModerationBadge,
  textSummarizationBadge,
  machineTranslationBadge,
  questionAnsweringBadge,
  relationExtractionBadge,
  taxonomyBadge,
  // Medical
  dicom3dBadge,
  dicomBboxBadge,
  dicomClassificationBadge,
  dicomKeypointBadge,
  dicomSegmentationBadge,
  // Videos
  videoClassificationBadge,
  videoFrameClassificationBadge,
  videoObjectTrackingBadge,
  videoTimelineSegmentationBadge,
  // Generative AI
  chatbotAssessmentBadge,
  humanFeedbackCollectionBadge,
  llmRankerBadge,
  responseGradingBadge,
  supervisedLlmBadge,
  visualRankerBadge,
  // Conversational AI
  intentSlotFillingBadge,
  responseGenerationBadge,
  responseSelectionBadge,
  coreferenceResolutionBadge,
  // Ranking and Scoring
  searchEngineBadge,
  serpRankingBadge,
  documentRetrievalBadge,
  textToImageBadge,
  contentBasedImageSearchBadge,
  asrHypothesesBadge,
  pairwiseClassificationBadge,
  pairwiseRegressionBadge,
  // Structured Data
  tabularDataBadge,
  pdfClassificationBadge,
  htmlEntityRecognitionBadge,
  freeformMetadataBadge,
  // Time Series
  timeSeriesForecastingBadge,
  anomalyDetectionBadge,
  changePointDetectionBadge,
  activityRecognitionBadge,
  signalQualityBadge,
};

// Category badges mapping by slug
export const categoryBadges: Record<string, string> = {
  "audiospeech-processing": audioSpeechProcessingBadge,
  chat: chatBadge,
  "computer-vision": computerVisionBadge,
  "conversational-ai": conversationalAiBadge,
  "generative-ai": generativeAiBadge,
  "medical-imaging": medicalImagingBadge,
  "natural-language-processing": naturalLanguageProcessingBadge,
  "ranking-and-scoring": rankingAndScoringBadge,
  "structured-data-parsing": structuredDataParsingBadge,
  "time-series-analysis": timeSeriesAnalysisBadge,
  "video-annotation": videosBadge,
  videos: videosBadge,
};

// All badges mapping by template/skill slug
export const allBadges: Record<string, string> = {
  ...categoryBadges,

  // Computer Vision
  "object-detection": objectDetectionBboxesBadge,
  "image-classification": imageClassificationBadge,
  "semantic-segmentation": semanticSegmentationMasksBadge,
  "image-captioning": imageCaptioningBadge,
  "ocrtext-recognition": ocrBadge,
  "keypoint-detection": keypointsBadge,

  // Medical
  "chest-x-ray-analysis": dicomClassificationBadge,
  "ct-scan-annotation": dicom3dBadge,
  "mri-segmentation": dicomSegmentationBadge,
  "pathology-slides": dicomClassificationBadge,
  "dental-imaging": dicomBboxBadge,

  // NLP
  "named-entity-recognition": namedEntityRecognitionBadge,
  "sentiment-analysis": textClassificationBadge,
  "text-classification": textClassificationBadge,
  "relation-extraction": relationExtractionBadge,
  "machine-translation-qa": machineTranslationBadge,

  // Audio Speech
  "audio-transcription": speechTranscriptionBadge,
  "speaker-diarization": speakerSegmentationBadge,
  "sound-event-detection": soundEventDetectionBadge,
  "music-annotation": asrUsingSegmentsBadge,

  // Videos
  "object-tracking": videoObjectTrackingBadge,
  "action-recognition": videoClassificationBadge,
  "temporal-segmentation": videoTimelineSegmentationBadge,
  "video-captioning": videoClassificationBadge,

  // Conversational AI
  "intent-classification": intentClassificationBadge,
  "dialog-act-tagging": intentSlotFillingBadge,
  "response-quality-rating": responseGradingBadge,

  // Generative AI
  "text-generation-qa": chatbotAssessmentBadge,
  "image-generation-rating": visualRankerBadge,
  "code-review": supervisedLlmBadge,
  "rlhf-preference-ranking": chatRlhfBadge,

  // Structured Data
  "document-parsing": pdfClassificationBadge,
  "receiptinvoice-extraction": freeformMetadataBadge,
  "table-recognition": tabularDataBadge,
};

/**
 * Get badge image URL by template/skill slug
 * @param slug - The template or skill slug (e.g., 'image-classification', 'computer-vision')
 * @returns The badge image URL or undefined if not found
 */
export function getBadge(slug: string): string | undefined {
  return allBadges[slug];
}

/**
 * Get category badge image URL
 * @param category - The category slug
 * @returns The category badge image URL or undefined if not found
 */
export function getCategoryBadge(category: string): string | undefined {
  return categoryBadges[category];
}
